import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
// eslint-disable-next-line import/no-cycle
import { useAuth } from '@pages/Shell';
import './styles.css';

import {
  mdiAccountOutline,
  mdiCardMultipleOutline,
  mdiCloseCircleOutline,
  mdiFileDocumentOutline,
  mdiHandHeartOutline,
  mdiHandshakeOutline,
  mdiHomeOutline,
} from '@mdi/js';

import { Fragment } from 'react/cjs/react.production.min';

import { useSelector } from 'react-redux';
import {
  BENEFICIOS,
  EMPRESTIMOS,
  HOME,
  LOGIN,
  MEUS_DADOS,
  OUTRAS_INFOS,
} from '../../utils/paths';
import Icons from '../Icon';
import { Tooltip } from '../Tooltip';

export const Sidebar = () => {
  const {
    transformacao_reserva: showTransformacaoReserva,
    saque_vista: showSaqueVista,
    reserva_matematica: showReservaMatematica,
    alterar_recebimento: showAlterarRecebimento,
    parcela_adicional: showParcelaAdicional,
    memoria_calculo: showMemoriaCalculo,
    informe_rendimento: showInforme,
    simular_conversao_beneficio: showConversao,
    contracheque: showContracheque,
    simular_beneficio: showBeneficio,
    simular_emprestimo: showSimular,
    contratos_aberto: showContratos,
  } = useSelector((state) => state.telasDisponiveis);

  const location = useLocation();
  const auth = useAuth();

  const checkPath = (path) => {
    const fragment = location.pathname.split('/');
    return fragment[1] === path;
  };

  const logout = () => {
    auth.signout();
  };

  return (
    <Fragment>
      <div className="d-none d-lg-block position-fixed" data-tour="step-2">
        <aside className="sidebar">
          <ul className="feature-list">
            <Tooltip
              title="Página inicial"
              className="tooltipMenu"
              arrow
              placement="right"
            >
              <NavLink to={HOME} activeclassname="active">
                <li>
                  <Icons
                    path={mdiHomeOutline}
                    color="#fff"
                    alt="Home"
                    size={1.25}
                  />
                </li>
              </NavLink>
            </Tooltip>
            <Tooltip
              title="Meus dados"
              className="tooltipMenu"
              arrow
              placement="right"
            >
              <NavLink to={MEUS_DADOS} activeclassname="active">
                <li>
                  <Icons
                    path={mdiAccountOutline}
                    color="#fff"
                    alt="Meus Dados"
                    size={1.25}
                  />
                </li>
              </NavLink>
            </Tooltip>
            {(showTransformacaoReserva ||
              showSaqueVista ||
              showReservaMatematica ||
              showAlterarRecebimento ||
              showParcelaAdicional ||
              showMemoriaCalculo ||
              showInforme ||
              showConversao ||
              showContracheque ||
              showBeneficio) && (
              <Tooltip
                title="Benefícios"
                className="tooltipMenu"
                arrow
                placement="right"
              >
                <NavLink to={BENEFICIOS} activeclassname="active">
                  <li>
                    <Icons
                      path={mdiHandHeartOutline}
                      color="#fff"
                      alt="File Icon"
                      size={1.25}
                    />
                  </li>
                </NavLink>
              </Tooltip>
            )}
            {(showSimular || showContratos) && (
              <Tooltip
                title="Empréstimos"
                className="tooltipMenu"
                arrow
                placement="right"
              >
                <NavLink
                  to={checkPath('emprestimos') ? '#' : EMPRESTIMOS}
                  activeclassname="active"
                >
                  <li>
                    <Icons
                      path={mdiHandshakeOutline}
                      color="#fff"
                      alt="Hand Coin icon"
                      size={1.25}
                    />
                  </li>
                </NavLink>
              </Tooltip>
            )}
            <Tooltip
              title="Requerimentos"
              className="tooltipMenu"
              arrow
              placement="right"
            >
              <NavLink to="/requerimentos/novo/*" activeclassname="active">
                <li>
                  <Icons
                    path={mdiFileDocumentOutline}
                    color="#fff"
                    alt="File Icon"
                    size={1.25}
                  />
                </li>
              </NavLink>
            </Tooltip>
            <NavLink to={OUTRAS_INFOS} activeclassname="active">
              <li>
                <Tooltip
                  title="Mapa de site"
                  className="tooltipMenu"
                  arrow
                  placement="right"
                >
                  <Icons
                    path={mdiCardMultipleOutline}
                    color="#fff"
                    alt="Mapa de site"
                    size={1.25}
                  />
                </Tooltip>
              </li>
            </NavLink>
          </ul>
        </aside>
        <div className="close">
          <NavLink to={LOGIN} onClick={logout}>
            <Icons
              path={mdiCloseCircleOutline}
              color="#fff"
              alt="Mapa de site"
              size={1.25}
            />
          </NavLink>
        </div>
      </div>
      <div className="d-block d-lg-none">
        <footer className="mobile-menu">
          <ul className="feature-list">
            <NavLink to={HOME} activeclassname="active">
              <li>
                <Icons
                  path={mdiHomeOutline}
                  color="#fff"
                  alt="Home"
                  size={1.25}
                />
                <span>Home</span>
              </li>
            </NavLink>
            <NavLink to={MEUS_DADOS} activeclassname="active">
              <li>
                <Icons
                  path={mdiAccountOutline}
                  color="#fff"
                  alt="Meus Dados"
                  size={1.25}
                />
                <span>Meus dados</span>
              </li>
            </NavLink>
            {(showTransformacaoReserva ||
              showSaqueVista ||
              showReservaMatematica ||
              showAlterarRecebimento ||
              showParcelaAdicional ||
              showMemoriaCalculo ||
              showInforme ||
              showConversao ||
              showContracheque ||
              showBeneficio) && (
              <NavLink to={BENEFICIOS} activeclassname="active">
                <li>
                  <Icons
                    path={mdiHandHeartOutline}
                    color="#fff"
                    alt="File Icon"
                    size={1.25}
                  />
                  <span>Benefícios</span>
                </li>
              </NavLink>
            )}

            {(showSimular || showContratos) && (
              <NavLink
                to={checkPath('emprestimos') ? '#' : EMPRESTIMOS}
                activeclassname="active"
              >
                <li>
                  <Icons
                    path={mdiHandshakeOutline}
                    color="#fff"
                    alt="Hand Coin icon"
                    size={1.25}
                  />
                  <span>Empréstimos</span>
                </li>
              </NavLink>
            )}

            <NavLink
              to={checkPath('requerimentos') ? '#' : `/requerimentos`}
              activeclassname="active"
            >
              <li>
                <Icons
                  path={mdiFileDocumentOutline}
                  color="#fff"
                  alt="File Icon"
                  size={1.25}
                />
                <span>Requerimentos</span>
              </li>
            </NavLink>
            <NavLink to={OUTRAS_INFOS} activeclassname="active">
              <li>
                <Icons
                  path={mdiCardMultipleOutline}
                  color="#fff"
                  alt="Outras informações"
                  size={1.25}
                />
                <span>Outros</span>
              </li>
            </NavLink>
          </ul>
        </footer>
      </div>
    </Fragment>
  );
};
